import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { decode, createMarkup } from 'lib/Utils'
import { connect } from 'react-redux'
import { selectLocation } from 'store/officeLocation'

import './index.scss'

class LocationListItem extends Component {
  render () {
    let location = this.props.location
    let classes = (this.props.selectedLocation === location.id) ? 'active' : ''
    return (
      <li className={`location-list__item ${classes}`} onClick={e => this.props.selectLocation(location.id)}>
        <address>
          <h2 className='small-title'>{decode(location.title.rendered)}</h2>
          <div dangerouslySetInnerHTML={createMarkup(location.acf.address)} />
          <div className='location-list__item__info'>
            <ul className='list-unstyled'>
              {location.acf.contact_emails.map((email, i) => {
                return <li key={`loc${location.id}email${i}`}><a href={`mailto:${email.email}`}>{email.email}</a></li>
              })}
            </ul>
            <ul className='list-unstyled'>
              {location.acf.contact_numbers.map((number, i) => {
                return <li key={`loc${location.id}phone${i}`}><strong>{number.desc}:</strong> {number.number}</li>
              })}
            </ul>
            {
              location.acf.google_maps_link &&
              <a className='location-list__item__link' href={location.acf.google_maps_link} target='_blank'>View on Google Maps</a>
            }
          </div>
        </address>
      </li>
    )
  }
}

LocationListItem.propTypes = {
  location: PropTypes.object,
  selectedLocation: PropTypes.number,
  selectLocation: PropTypes.func
}

const mapDispatchToProps = {
  selectLocation: (locationID) => selectLocation(locationID)
}

const mapStateToProps = (state) => ({
  selectedLocation: state.selectedLocation
})

export default connect(mapStateToProps, mapDispatchToProps)(LocationListItem)



// WEBPACK FOOTER //
// ./src/containers/LocationListItem/index.js